import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {filterArticle_template} from "./filterArticle_template";
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {
    validationsList_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;

let quizUniqueIdCounter = 0;

export class quizPickerEdit_template extends vnTemplate {
    protected parent: any;
    protected brandsFilter: multipleSelector_template;
    protected filterArticle: filterArticle_template;
    public validationsList: validationsList_template;
    private pendingScrollToNewQuestion: boolean = false;
    protected insertDropdownDocumentClickHandler: ((event: MouseEvent) => void) | null = null;

    protected getTemplateHtml(): string {
        return /* html */ `
      <div class="w-picker-form form-edit quiz-edit-layout" id="quiz-picker-edit" data-bind="css: { 'is-visible': isShown }">
        <div class="picker-form">
          <div class="form-header w-justify">
            <input id="quiz-picker-id" data-bind="value: id" type="hidden">
            <div class="w-left"></div>
            <div class="w-center">
              <div class="section-title">
                <h3 class="section-title icon i-poll" data-bind="text: id() != null ? 'Edit Quiz' : 'Add Quiz'"></h3>
              </div>
            </div>
            <div class="w-right">
              <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
            </div>
          </div>

          ${this.validationsList.getHtmlBuild()}

          <div class="w-form-body quiz-picker-scroll">
              <div id="quiz-picker-info-section" class="w-poll-body quiz-picker-info-section">
                <div class="w-form-body w-poll-sections-list">
                  <div class="form-body">
                    <div class="form-group quiz-picker-section-heading">
                      <label for="quiz-picker-title" class="form-label quiz-picker-section-heading__label">Title</label>
                    </div>
                    <div class="form-group quiz-picker-title-input">
                      <input id="quiz-picker-title" class="input-text" type="text" data-bind="value: title, valueUpdate: 'keyup'">
                    </div>

                    <div class="form-group quiz-picker-brands-row">
                      <div class="quiz-picker-brands-filter">
                        ${this.brandsFilter.getHtmlBuild()}
                      </div>
                      <div id="quiz-picker-selected-brands" class="quiz-picker-brand-tags"></div>
                    </div>
                  </div>

                  <div class="quiz-picker-article-section">
                    <div class="form-group quiz-picker-section-heading">
                      <label class="form-label quiz-picker-section-heading__label">Source Article</label>
                    </div>
                    <div class="form-body quiz-picker-article-panel">
                      <div class="form-group quiz-picker-article-search">
                        <div class="quiz-picker-article-search__field">
                          ${this.filterArticle.getHtmlBuild()}
                        </div>
                      </div>

                      <div class="w-filters-selected quiz-picker-selected-articles">
                        <strong>Selected Articles:</strong>
                        <div id="quiz-picker-selected-source-article" class="filters-selected"></div>
                      </div>

                      <div class="form-group quiz-picker-generate-actions">
                        <button data-bind="event: { click: onClickGenerate }, enable: idSourceArticle" class="btn secondary" type="button">Generate from Article</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="quiz-picker-widgets-section-quiz" class="w-poll-body quiz-picker-widgets-section">
                <div class="w-form-body w-poll-sections-list">
                  <div class="form-body">
                    <div class="form-group widget-controls">
                      <button class="btn-fab btn-fab--small rounded secondary icon-end" type="button" data-bind="event: { click: onClickAddQuizQuestion }">
                        <div class="icon i-plus"></div>
                        <div class="fab-label">Add Question</div>
                      </button>
                      <span class="widget-controls__alert" data-bind="visible: isQuizContentInvalid()">Incomplete content will not sync to the website.</span>
                      <button class="quiz-picker-toggle-all-btn" type="button" data-bind="visible: quizQuestions().length > 0, event: { click: onClickToggleAllQuizQuestions }, text: toggleAllQuizLabel"></button>
                    </div>
                  </div>
                </div>
    
                <div class="form-group" data-bind="foreach: quizQuestions, childrenComplete: handleDragAndDrop($element, quizQuestions, '.quiz-question-block', { collapseOnDrag: true, dragHandleSelector: '.drag-handle' })">
                  <div class="quiz-question-block" data-bind="attr: { 'data-is-from': isFromAi() ? 'ai' : 'user' }">
                    <div class="quiz-question-block__header">
                      <div class="quiz-question-block__title">
                        <span class="icon i-drag drag-handle"></span>
                        <strong class="quiz-question-block__index" data-bind="text: 'Question ' + ($index() + 1), click: toggleCollapsed"></strong>
                        <button class="btn-fab no-style icon-only icon--xlarge icon i-dropdown-simple" data-bind="click: toggleCollapsed, css: { 'is-open' : !isCollapsed() }" type="button"></button>
                        <span class="quiz-question-block__preview" data-bind="visible: isCollapsed, text: question() ? ': ' + question() : '', click: toggleCollapsed"></span>
                      </div>
                      <button class="btn border only-icon icon i-delete" type="button" title="Remove Question" data-bind="event: { click: function() { $parent.onClickRemoveQuizQuestion($index()) } }"></button>
                    </div>
    
                    <div class="quiz-question-block__body" data-bind="visible: !isCollapsed()">
                      <div class="quiz-question-field-row">
                        <label class="form-label">Question</label>
                        <textarea class="input-text quiz-question-input" data-bind="value: question, valueUpdate: 'input'" placeholder="Enter question text"></textarea>
                      </div>
    
                      <div class="quiz-question-field-row quiz-question-field-row--split">
                        <div class="quiz-question-field">
                          <label class="form-label">Difficulty</label>
                          <select class="input-text" data-bind="value: difficulty">
                            <option value="easy">Easy</option>
                            <option value="medium">Medium</option>
                            <option value="hard">Hard</option>
                          </select>
                        </div>
                        <div class="quiz-question-field">
                          <label class="form-label">Basis</label>
                          <select class="input-text" data-bind="value: basis">
                            <option value="article">Article</option>
                            <option value="topic">Topic</option>
                          </select>
                        </div>
                      </div>
    
                      <div class="quiz-question-field-row">
                        <label class="form-label">Rationale</label>
                        <textarea class="input-text quiz-question-input quiz-question-input--tall" data-bind="value: rationale, valueUpdate: 'input'" placeholder="Rationale for correct answer"></textarea>
                      </div>
    
                      <div class="quiz-options">
                        <label class="form-label">Answer Options</label>
                        <div data-bind="foreach: options">
                          <div class="quiz-option-row">
                            <input type="text" class="input-text quiz-question-input" data-bind="value: text, valueUpdate: 'input'" placeholder="Option text" />
                            <label class="quiz-option-correct-label">
                              <input type="radio"
                                data-bind="checked: $parent.correctOptionIndex, checkedValue: $index(), attr: { name: 'quizPickerCorrectOption' + $parent.uniqueId }" />
                              Correct
                            </label>
                            <button class="btn border only-icon icon i-delete" type="button" title="Remove Option" data-bind="event: { click: function() { $parents[1].onClickRemoveQuizOption($parent, $index()) } }"></button>
                          </div>
                        </div>
                        <button class="btn" type="button" data-bind="event: { click: function() { $parent.onClickAddQuizOption($data) } }">+ Add Option</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="form-footer">
            <button type="button" class="btn" data-bind="event: { click: onClickCancel }">Cancel</button>
            <button type="button" class="btn highlight" data-bind="event: { click: onClickSave }">Save</button>
            <div class="insert-dropdown" data-bind="css: { 'is-open': isInsertDropdownOpen }">
              <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button" data-bind="event: { click: onClickToggleInsertDropdown }"><span>Save & Insert</span></button>
              <div class="insert-dropdown-list">
                <button class="btn-icon icon i-ins" type="button" data-bind="event: { click: onClickSaveAndInsert.bind($data, true) }" title="Save and Insert with Dynamic Placement"><span>Dynamic Using Sentinel Avg. Scroll Depth %</span></button>
                <button class="btn-icon icon i-ins" type="button" data-bind="event: { click: onClickSaveAndInsert.bind($data, false) }" title="Save and Insert without Dynamic Placement"><span>Static Placement</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            isShown: ko.observable(false),
            id: ko.observable(null),
            title: ko.observable(""),
            idSourceArticle: ko.observable(null),
            idSourceArticleBrand: ko.observable(null),
            brands: ko.observableArray([]),
            quizQuestions: ko.observableArray([]),
            isQuizDynamicPlacementOnByDefault: ko.observable(false),
            isQuizDynamicPlacement: ko.observable(false),
            isInsertDropdownOpen: ko.observable(false),
            isQuizContentInvalid: ko.pureComputed(() => {
                const questions = self.getTemplateViewModel().quizQuestions();
                if (!questions || questions.length === 0) {
                    return false;
                }

                return questions.some((question) => {
                    return question && typeof question.isQuestionValid === "function"
                        ? !question.isQuestionValid()
                        : false;
                });
            }),
            toggleAllQuizLabel: ko.pureComputed(() => {
                const quizQuestions = self.getTemplateViewModel().quizQuestions();
                const anyExpanded = quizQuestions.some(question => !ko.unwrap(question.isCollapsed));
                return anyExpanded ? "Collapse All" : "Expand All";
            }),
            onClickAddQuizQuestion: function () {
                self.addQuizQuestion();
            },
            onClickToggleAllQuizQuestions: function () {
                self.toggleAllQuizQuestions();
            },
            onClickAddQuizOption: function (question) {
                self.addQuizOption(question);
            },
            onClickRemoveQuizOption: function (question, optionIndex) {
                self.removeQuizOption(question, optionIndex);
            },
            onClickRemoveQuizQuestion: function (questionIndex) {
                self.removeQuizQuestion(questionIndex);
            },
            onClickCancel: function () {
                self.hide();
            },
            onClickSave: function () {
                self.onClickSave();
            },
            onClickSaveAndInsert: function (isQuizDynamicPlacement) {
                self.onClickSaveAndInsert(isQuizDynamicPlacement);
            },
            onClickToggleInsertDropdown: function (data, event) {
                event.stopPropagation();
                self.toggleInsertDropdown();
            },
            onClickGenerate: function () {
                self.onClickGenerate();
            },
            handleDragAndDrop: (element, currentObservableArray, childrenSelector, options = {}) => {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector, options);
            },
        };
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector, options = {}): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector, options);

        if (this.pendingScrollToNewQuestion) {
            this.pendingScrollToNewQuestion = false;
            const children = element.querySelectorAll(childrenSelector);
            const lastChild = children[children.length - 1];
            if (lastChild) {
                lastChild.scrollIntoView({behavior: "smooth", block: "start"});
            }
        }
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("quizPickerEditValidationsList", this.getTemplateViewModel(), this.caller);
        this.validationsList.setWidth("50%");

        this.brandsFilter = new multipleSelector_template("quizPickerBrandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel("Brands");
        this.brandsFilter.setFilterContainerClass('margin-neg');
        this.brandsFilter.setTagContainerId('quiz-picker-selected-brands');
        this.brandsFilter.setTagContainerCaption('');

        this.filterArticle = new filterArticle_template("quizPickerFilterArticle", this.getTemplateViewModel(), this.caller);
        this.filterArticle.setSelectionMode(filterArticle_template.MULTIPLE_SELECTION_MODE);
        this.filterArticle.setShowDetails(true);
        this.filterArticle.setShowSelectedArticlesDetails(true);
        this.filterArticle.setTagContainerId("quiz-picker-selected-source-article");
        this.filterArticle.setIsLoadingAnimationEnable(true);
    }

    protected getTemplateName(): string {
        return "quizPickerEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    public setParent(parent): this {
        this.parent = parent;
        return this;
    }

    public setQuiz(quiz): void {
        const currentBrandId = this.parent && this.parent.getIdBrand ? this.parent.getIdBrand() : null;
        const mappedQuestions = (quiz.quiz || []).map((question) => this.buildQuizQuestion(question));

        this.clearValidationMessages();
        this.setId(quiz.id || null);
        this.setTitle(quiz.title || "");
        this.setIdSourceArticle(quiz.idSourceArticle || null);
        this.setIdSourceArticleBrand(quiz.idSourceArticleBrand || null);
        this.setSelectedSourceArticle(quiz.sourceArticle || quiz.article || null);
        this.setQuizQuestions(mappedQuestions);
        this.setAttachedBrandIds((quiz.brands && quiz.brands.length > 0) ? quiz.brands : (currentBrandId ? [currentBrandId] : []));
    }

    public getQuizForRequest(): any {
        const quizQuestionsRaw = ko.toJS(this.getTemplateViewModel().quizQuestions());

        quizQuestionsRaw.forEach((question) => {
            if (question.options) {
                question.options.forEach((option, index) => {
                    option.isCorrect = question.correctOptionIndex === index ? "on" : undefined;
                });
            }

            const questionModel = this.getTemplateViewModel()
                .quizQuestions()
                .find((existingQuestion) => existingQuestion.uniqueId === question.uniqueId);
            question.isValid = questionModel ? questionModel.isQuestionValid() : false;
            delete question.correctOptionIndex;
            delete question.isCollapsed;
        });

        return {
            id: this.getTemplateViewModel().id(),
            title: this.getTemplateViewModel().title(),
            idSourceArticle: this.getIdSourceArticle(),
            idSourceArticleBrand: this.getIdSourceArticleBrand(),
            brands: this.brandsFilter.getSelectedItems(),
            quiz: quizQuestionsRaw,
            regenerate: false,
        };
    }

    public show(): void {
        this.getTemplateViewModel().isShown(true);
    }

    public hide(): void {
        this.closeInsertDropdown();
        this.getTemplateViewModel().isShown(false);
    }

    public setValidationMessages(messages): void {
        this.validationsList.setMessages(messages || []);
    }

    public setSingleValidationMessage(message): void {
        this.validationsList.setSingleMessage(message);
    }

    public clearValidationMessages(): void {
        this.validationsList.clearMessages();
    }

    public showLoading(): void {
        const form = document.getElementById("quiz-picker-edit");
        form && form.classList.add("loading");
    }

    public hideLoading(): void {
        const form = document.getElementById("quiz-picker-edit");
        form && form.classList.remove("loading");
    }

    protected onClickSave(): void {
        this.parent.saveQuiz(this.getQuizForRequest());
    }

    protected onClickSaveAndInsert(isQuizDynamicPlacement): void {
        this.closeInsertDropdown();
        this.setIsQuizDynamicPlacement(isQuizDynamicPlacement);
        this.parent.saveQuiz(this.getQuizForRequest(), true, isQuizDynamicPlacement);
    }

    protected toggleInsertDropdown(): void {
        const willOpen = !this.getTemplateViewModel().isInsertDropdownOpen();
        this.getTemplateViewModel().isInsertDropdownOpen(willOpen);
        if (willOpen) {
            this.bindInsertDropdownDocumentClick();
        } else {
            this.unbindInsertDropdownDocumentClick();
        }
    }

    protected bindInsertDropdownDocumentClick(): void {
        this.unbindInsertDropdownDocumentClick();
        this.insertDropdownDocumentClickHandler = (event: MouseEvent) => {
            const target = event.target as Element | null;
            if (!target || !target.closest(".insert-dropdown")) {
                this.closeInsertDropdown();
            }
        };
        window.setTimeout(() => {
            if (this.getTemplateViewModel().isInsertDropdownOpen() && this.insertDropdownDocumentClickHandler) {
                document.addEventListener("click", this.insertDropdownDocumentClickHandler);
            }
        }, 0);
    }

    protected unbindInsertDropdownDocumentClick(): void {
        if (this.insertDropdownDocumentClickHandler) {
            document.removeEventListener("click", this.insertDropdownDocumentClickHandler);
            this.insertDropdownDocumentClickHandler = null;
        }
    }

    protected closeInsertDropdown(): void {
        this.getTemplateViewModel().isInsertDropdownOpen(false);
        this.unbindInsertDropdownDocumentClick();
    }

    protected onClickGenerate(): void {
        this.parent.saveQuiz({
            ...this.getQuizForRequest(),
            regenerate: true,
        });
    }

    protected buildQuizQuestion(questionData): any {
        const question = ko.observable(questionData.question || "");
        const rationale = ko.observable(questionData.rationale || questionData.answer || "");
        const options = ko.observableArray((questionData.options || []).map((option) => ({
            text: ko.observable(option.text || option.option || option.choiceText || ""),
            isCorrect: ko.observable(option.isCorrect === true || option.isCorrect === "on"),
        })));
        const foundIndex = (questionData.options || []).findIndex((option) => {
            return option.isCorrect === true || option.isCorrect === "on";
        });

        const quizQuestion = {
            uniqueId: questionData.uniqueId || "quiz_picker_" + (++quizUniqueIdCounter),
            isValid: questionData.isValid || false,
            question: question,
            difficulty: ko.observable(questionData.difficulty || "easy"),
            basis: ko.observable(questionData.basis || "topic"),
            rationale: rationale,
            correctOptionIndex: ko.observable(foundIndex !== -1 ? foundIndex : this.getCorrectOptionIndexFromAnswer(questionData)),
            isCollapsed: ko.observable(false),
            isFromAi: ko.observable(questionData.isFromAi === true),
            toggleCollapsed: function () {
                this.isCollapsed(!this.isCollapsed());
            },
            isQuestionValid: null,
            options: options,
        };

        quizQuestion.isQuestionValid = ko.pureComputed(() => {
            const questionValue = question() || "";
            const rationaleValue = rationale() || "";
            const optionValues = options() || [];
            if (questionValue.trim() === "" || rationaleValue.trim() === "" || optionValues.length === 0) {
                return false;
            }

            return optionValues.every((option) => option.text().trim() !== "");
        });

        return quizQuestion;
    }

    protected getCorrectOptionIndexFromAnswer(questionData): number {
        const answer = questionData.answer || "";
        if (!answer || !questionData.options) {
            return 0;
        }

        const index = questionData.options.findIndex((option) => {
            const optionText = option.text || option.option || option.choiceText || "";
            return optionText === answer;
        });

        return index !== -1 ? index : 0;
    }

    protected addQuizQuestion(): void {
        const quizQuestions = this.getTemplateViewModel().quizQuestions;
        const existingQuestions = quizQuestions();
        if (existingQuestions && existingQuestions.length > 0) {
            if (existingQuestions.length > quizUniqueIdCounter) {
                quizUniqueIdCounter = existingQuestions.length;
            }

            existingQuestions.forEach(question => {
                const uid = question.uniqueId;
                if (uid && typeof uid === "string" && uid.startsWith("quiz_picker_new_")) {
                    const num = parseInt(uid.replace("quiz_picker_new_", ""), 10);
                    if (!isNaN(num) && num > quizUniqueIdCounter) {
                        quizUniqueIdCounter = num;
                    }
                }
            });
        }

        this.pendingScrollToNewQuestion = true;

        quizQuestions.push(this.buildQuizQuestion({
            uniqueId: "quiz_picker_new_" + (++quizUniqueIdCounter),
            question: "",
            difficulty: "easy",
            basis: "topic",
            rationale: "",
            options: [
                {text: ""},
                {text: ""},
                {text: ""},
                {text: ""},
            ],
        }));
    }

    public toggleAllQuizQuestions(): void {
        const quizQuestions = this.getTemplateViewModel().quizQuestions();
        if (quizQuestions.length === 0) {
            return;
        }

        const anyExpanded = quizQuestions.some(question => !ko.unwrap(question.isCollapsed));
        quizQuestions.forEach(question => {
            if (typeof question.isCollapsed === "function") {
                question.isCollapsed(anyExpanded);
            }
        });
    }

    protected addQuizOption(question): void {
        question.options.push({
            text: ko.observable(""),
            isCorrect: ko.observable(false),
        });
    }

    protected removeQuizOption(question, optionIndex): void {
        question.options.splice(optionIndex, 1);
        const correctIndex = ko.unwrap(question.correctOptionIndex);
        if (correctIndex >= question.options().length) {
            question.correctOptionIndex(Math.max(question.options().length - 1, 0));
        }
    }

    protected removeQuizQuestion(questionIndex): void {
        this.getTemplateViewModel().quizQuestions.splice(questionIndex, 1);
    }

    public setReferences(references): void {
        this.setBrandsReferences(references.brands || []);
    }

    public setBrandsReferences(brands): void {
        this.brandsFilter.setItems(brands || []);
    }

    public setArticlesFilter(articles): void {
        this.filterArticle.setShowDetails(true);
        this.filterArticle.setOptions(this.formatSourceArticlesForDisplay(articles || []));
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setTitle(title): void {
        this.getTemplateViewModel().title(title);
    }

    public setIdSourceArticle(idSourceArticle): void {
        this.getTemplateViewModel().idSourceArticle(idSourceArticle);
    }

    public getIdSourceArticle() {
        const selectedArticle = this.getSelectedSourceArticle();
        return selectedArticle && selectedArticle.id ? selectedArticle.id : this.getTemplateViewModel().idSourceArticle();
    }

    public setIdSourceArticleBrand(idSourceArticleBrand) {
        this.getTemplateViewModel().idSourceArticleBrand(idSourceArticleBrand);
    }

    public getIdSourceArticleBrand() {
        return this.getTemplateViewModel().idSourceArticleBrand();
    }


    public syncSelectedSourceArticle(): void {
        const selectedArticle = this.getSelectedSourceArticle();
        this.setIdSourceArticle(selectedArticle && selectedArticle.id ? selectedArticle.id : null);
    }

    protected getSelectedSourceArticle(): any {
        const selectedArticles = this.filterArticle.getArticleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            const selectedArticle = selectedArticles[selectedArticles.length - 1];
            if (selectedArticles.length > 1) {
                this.filterArticle.resetArticleContainer();
                this.filterArticle.setArticles(selectedArticle);
            }

            return selectedArticle;
        }

        return this.filterArticle.getArticleObj();
    }

    public setSelectedSourceArticle(article): void {
        if (article && article.id) {
            this.filterArticle.resetArticleContainer();
            this.filterArticle.setArticles(this.formatSourceArticleForDisplay(article));
            this.setIdSourceArticle(article.id);
            return;
        }

        const idSourceArticle = this.getTemplateViewModel().idSourceArticle();
        if (idSourceArticle) {
            this.filterArticle.resetArticleContainer();
            this.filterArticle.setArticles(this.formatSourceArticleForDisplay({
                id: idSourceArticle,
                title: "Article #" + idSourceArticle,
                brandName: this.getSourceArticleBrandName(),
            }));
        } else {
            this.filterArticle.resetArticleContainer();
        }
    }

    protected formatSourceArticlesForDisplay(articles): Array<any> {
        return (articles || []).map((article) => this.formatSourceArticleForDisplay(article));
    }

    protected formatSourceArticleForDisplay(article): any {
        if (!article) {
            return article;
        }

        return {
            ...article,
            title: this.getSourceArticleDisplayTitle(article),
        };
    }

    protected getSourceArticleDisplayTitle(article): string {
        const title = article.title || "";
        const id = article.id || "";
        const brandName = this.getSourceArticleBrandName(article);

        return `${title} (${id} - ${brandName})`;
    }

    protected getSourceArticleBrandName(article = null): string {
        if (article) {
            const articleBrandName = article.brandName || article.brandShortName || article.brand || article.shortName;
            if (articleBrandName) {
                return articleBrandName;
            }
        }

        const sourceArticleBrandId = this.getTemplateViewModel().idSourceArticleBrand();
        const brand = (this.brandsFilter.getItems() || []).find((brandReference) => {
            return Number(brandReference.id) === Number(sourceArticleBrandId);
        });

        return brand ? (brand.name || brand.shortName || "") : "";
    }

    public setQuizQuestions(quizQuestions): void {
        this.getTemplateViewModel().quizQuestions(quizQuestions);
    }

    public setAttachedBrandIds(brandIds): void {
        const selectedBrandIds: Array<number> = Array.from(new Set((brandIds || []).map((brandId) => Number(brandId))));
        this.getTemplateViewModel().brands(selectedBrandIds);
        this.brandsFilter.setSeletedItemIds(selectedBrandIds, false);
        this.brandsFilter.setTags(selectedBrandIds, this.brandsFilter.getItems());
    }

    public setIsQuizDynamicPlacementOnByDefault(isQuizDynamicPlacementOnByDefault): void {
        this.getTemplateViewModel().isQuizDynamicPlacementOnByDefault(!!isQuizDynamicPlacementOnByDefault);
    }

    public setIsQuizDynamicPlacement(isQuizDynamicPlacement): void {
        this.getTemplateViewModel().isQuizDynamicPlacement(!!isQuizDynamicPlacement);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/quizPickerEdit_template.ts